module.exports = __webpack_public_path__ + "static/media/facebook.34e73505.svg";